import { AppError } from '../core/errors.js';

export async function apiRequest(url, options = {}) {
  const response = await fetch(url, options);
  if (!response.ok) {
    let payload = null;
    try { payload = await response.json(); } catch { payload = null; }
    throw new AppError(payload?.error || `API ${response.status}`, {
      code: payload?.code || 'API_ERROR',
      status: response.status,
      details: payload
    });
  }
  if (response.status === 204) return null;
  return response.json();
}
